import script from "./cultureAndValues.vue?vue&type=script&lang=ts&setup=true"
export * from "./cultureAndValues.vue?vue&type=script&lang=ts&setup=true"

import "./cultureAndValues.vue?vue&type=style&index=0&id=150a9ea4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-150a9ea4"]])

export default __exports__